import React, { useEffect, useState, useContext } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";

function CorrectStudentPage9() {
  const { setClass9exregulardata, setModeex } = useContext(ContextBoard);
  const navigate = useNavigate();

  // ---------------- CANDIDATE ID ----------------
  const [candidateId, setCandidateId] = useState("");
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   setClass10regulardata("");
  // }, [navigate]);

  const handleSearch = async () => {
    if (!candidateId) {
      Swal.fire("Warning", "Please enter Candidate ID", "warning");
      return;
    }
    if (candidateId.length > 20) {
      Swal.fire("Warning", "Candidate ID cannot exceed 20 digits", "warning");
      return;
    }

    setLoading(true);
    const token = sessionStorage.getItem("tokenclassix");

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/SchoolForCorrectionPortal_CL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            candidatE_ID: candidateId,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        Swal.fire("Error", data?.message || "Invalid Candidate ID", "error");
        return;
      }
      const studentCategory = data?.data?.studenT_EXAM_CATEGORY_DESCRIPTION;
      const fetchedCandidateId = data?.data?.candidatE_ID;

      // if (studentCategory === "EX-REGULAR") {
      //   const res = await fetch(
      //     `${config.API_BASE_URL}/CheckingDataEXRegularStudent_CL9`,
      //     {
      //       method: "POST",
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${token}`,
      //       },
      //       body: JSON.stringify({ candidatE_ID: fetchedCandidateId }),
      //     }
      //   );

      //   const result = await res.json();
      //   if (!res.ok) throw new Error(result.message);

      //   navigate("class-ix-correct-ex-student", {
      //     state: { studentData: result.data.editStudent_data },
      //   });
      // } else {
      const res = await fetch(
        `${config.API_BASE_URL}/EditStudentRegistration_CL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ candidatE_ID: fetchedCandidateId }),
        }
      );

      const result = await res.json();
      if (!res.ok) throw new Error(result.message);

      // setClass10regulardata(true);
      if (result.data.editStudent_data.prinT_CATEGORY === "EX-REGULAR") {
        setModeex("edit");
        setClass9exregulardata(result.data.editStudent_data);
        navigate("/class-ix-correct-ex-student");
      } else {
        navigate("/class-ix-correct-student-regular", {
          state: { candidateData: result.data.editStudent_data },
        });
      }

      // }
    } catch (error) {
      Swal.fire("Error", error.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              <section className="content-header">
                <h1>
                  <i className="fa fa-user"></i>&nbsp;Correct Student Data
                  <span className="text-danger">
                    {" "}
                    (Only challan generated students)
                  </span>
                </h1>

                <ol className="breadcrumb">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-ix-dashboard");
                      }}
                    >
                      Home
                    </a>
                  </li>
                  <li className="active">Correct Student Data</li>
                </ol>
              </section>

              {/* ---------------- SEARCH CARD ---------------- */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      <div className="col-md-3">
                        <label className="mb-2">
                          Please Enter Candidate ID :
                        </label>
                        <input
                          type="text"
                          value={candidateId}
                          onChange={(e) => setCandidateId(e.target.value)}
                          maxLength={20}
                          className="form-control form-control-xs"
                          placeholder="Candidate ID"
                        />
                      </div>

                      <div className="col-md-2">
                        <button
                          className="btn btn-primary mt-4"
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i>&nbsp;Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default CorrectStudentPage9;
